import {
  contactsData3,
  contactsDataPost3,
  contactsDataUpdate3,
  contactsDataDelete3,
} from "./WagonContactsActions";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ErrorResponse } from "src/types/error-response.type";
import { SuccessResponse } from "src/types/success-response.type";
import { ContactWithID }  from '../../types/request.type';





type ContactsState3 = {
  dataContacts3: {
    payload: ContactWithID[] | null;
    payload_update: ContactWithID | null;
    loading: boolean;
    success: boolean;
    error: string | null;
  };
};

const initialState3: ContactsState3 = {
  dataContacts3: {
    loading: false,
    success: false,
    payload_update: null,
    payload: [],
    error: "",
  },
};




 const contactsSlice3 = createSlice({
  name: "contacts3",
  initialState: initialState3,
  reducers: {
    // Обычные редьюсеры
    setContactsState(state, action: PayloadAction<ContactWithID[]>) {
      state.dataContacts3.payload = [];
      state.dataContacts3.payload = action.payload;
    },

    setContactsUpdateState(state, action: PayloadAction<ContactWithID>) {
      state.dataContacts3.payload_update = null;
      state.dataContacts3.payload_update = action.payload;
     // console.log(state.dataContacts3.payload_update);
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(contactsData3.pending, (state) => {
        state.dataContacts3.loading = true;
        state.dataContacts3.error = null;
      })
      .addCase(contactsData3.fulfilled, (state, action) => {
        state.dataContacts3.loading = false;
        contactsSlice3.caseReducers.setContactsState(state, action);
      })
      .addCase(contactsData3.rejected, (state, action) => {
        state.dataContacts3.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataContacts3.error = errorText ? errorText : "";
      })

      ////
      .addCase(contactsDataPost3.pending, (state) => {
        state.dataContacts3.loading = true;
        state.dataContacts3.error = "";
      })
      .addCase(contactsDataPost3.fulfilled, (state, action) => {
        state.dataContacts3.loading = false;
        //clientsSlice.caseReducers.setClientsState(state, action);
      })
      .addCase(contactsDataPost3.rejected, (state, action) => {
        state.dataContacts3.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataContacts3.error = errorText ? errorText : "";
      })

      ////
      .addCase(contactsDataUpdate3.pending, (state) => {
        state.dataContacts3.loading = true;
        state.dataContacts3.error = "";
      })
      .addCase(contactsDataUpdate3.fulfilled, (state, action) => {
        state.dataContacts3.loading = false;
        contactsSlice3.caseReducers.setContactsUpdateState(state, action);
      })
      .addCase(contactsDataUpdate3.rejected, (state, action) => {
        state.dataContacts3.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataContacts3.error = errorText ? errorText : "";
      })

      ////
      .addCase(contactsDataDelete3.pending, (state) => {
        state.dataContacts3.loading = true;
        state.dataContacts3.error = "";
      })
      .addCase(contactsDataDelete3.fulfilled, (state, action) => {
        state.dataContacts3.loading = false;
        //clientsSlice.caseReducers.setClientsState(state, action);
      })
      .addCase(contactsDataDelete3.rejected, (state, action) => {
        state.dataContacts3.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataContacts3.error = errorText ? errorText : "";
      });
  },
});





const getErrorText = (error: ErrorResponse) => {
 // console.log(error);

  switch (error?.error) {
    case "invalid0":
      return "invalid0";
    case "invalid1":
      return "invalid1";
    default:
      return "";
  }
};

export default contactsSlice3.reducer;

